import {
	useEffect,
	useRef,
	useState,
} from 'react';
import { NativeStackScreenProps } from '@react-navigation/native-stack';
import { PrivateStackParamList } from '../../navigationApp/types';
import {
	Animated,
	Platform,
	View,
} from 'react-native';
import LottieView from 'lottie-react-native';
import { ThemedText, ThemedView } from '@app/theme';

const CheckingLimit = ({ navigation, route }: NativeStackScreenProps<PrivateStackParamList, 'CHECKING_LIMIT'>) => {
	const [dotCount, setDotCount] = useState(0);
	const [messageIndex, setMessageIndex] =
		useState(0);
	const animationRef = useRef(null);

	useEffect(() => {
		if (animationRef.current) {
            //@ts-expect-error
			animationRef?.current?.play();
		}
	}, []);

	useEffect(() => {
		setTimeout(() => {
			if (Platform.OS === 'web') {
				navigation.replace('UNLOCK_LIMIT_LANDING' as any);
			} else {
				navigation.reset({
					index: 0,
					routes: [
						{
							name: "HOME"
						},
						{
							name: 'UNLOCK_LIMIT_LANDING',
						},
					],
				});
			}
		}, 3000);
	}, []);

	const messages = [
		'Setting up a secure connection',
		'Getting your portfolio details',
		'Calculating your credit limit',
		'Please wait, we’re almost there',
	];
	const dots = ['.', '..', '...'];

	const fadeAnim = new Animated.Value(0);
	useEffect(() => {
		setDotCount(0);

		const dotInterval = setInterval(() => {
			setDotCount((prev) => (prev + 1) % 3);
		}, 1000);

		Animated.timing(fadeAnim, {
			toValue: 1,
			duration: 3000,
			useNativeDriver: true,
		}).start();

		const messageInterval = setInterval(() => {
			if (messageIndex < messages.length - 1) {
				setMessageIndex(
					(prev) => (prev + 1) % messages.length,
				);
			}
		}, 3000);

		return () => {
			clearInterval(dotInterval);
			clearInterval(messageInterval);
		};
	}, [messageIndex]);
	return (
		<ThemedView
			alignContent='center'
			justifyContent='center'
			alignItems='center'
			alignSelf='center'
			flex={1}
			backgroundColor='white'
			width='100%'
		>
			<ThemedView alignContent='center'>
                <ThemedText
                    variant={'h3s'}
                    color={'text-primary'}
                    textAlign={'center'}
                >
                    Evaluating your mutual funds.
                </ThemedText>
				<ThemedView
					alignContent='center'
					alignItems='center'
				>
					{Platform.OS !== 'web' ? (
						Platform.OS === 'ios' ? (
							<LottieView
								source={{
									uri: 'https://lottie.host/abc9bfeb-0b42-4752-9def-a939baa72d6f/K6kJJnKohX.json',
								}}
								loop={true}
								autoPlay={true}
								ref={animationRef}
								style={{ width: 340, height: 170 }}
							/>
						) : (
							<LottieView
								source={require('../../../src/assets/lotties/fetch_funds_animation.json')}
								loop={true}
								autoPlay={true}
								ref={animationRef}
								style={{ width: 340, height: 170 }}
							/>
						)
					) : (
						<LottieView
							source={require('../../../src/assets/lotties/fetch_funds_animation.json')}
							loop={true}
							autoPlay={true}
							ref={animationRef}
						/>
					)}

					<Animated.Text
						style={{
							fontSize: 14,
							fontWeight: '400',
							opacity: fadeAnim,
							fontFamily: 'Inter',
							color: '#000',
						}}
					>
						{messages[messageIndex]}
						{dots[dotCount]}
					</Animated.Text>
				</ThemedView>
			</ThemedView>
		</ThemedView>
	);
};

export default CheckingLimit;
